import { Component, OnInit } from '@angular/core';
import {
  availableGridTypesResponse,
  TournamentTunerMethodsService
} from "../../../../services/tournament-tuner-methods.service";
import {ResourceTypeForDiagnostics} from "@angular/compiler-cli/src/ngtsc/annotations/src/component";
import {typeofExpr} from "@angular/compiler/src/output/output_ast";

@Component({
  selector: 'app-tournament-tuner-groups-part',
  templateUrl: './tournament-tuner-groups-part.component.html',
  styleUrls: ['./tournament-tuner-groups-part.component.scss']
})
export class TournamentTunerGroupsPartComponent implements OnInit {


  public groupsMaximalAmount: number;
  public playersExitingGroupsMaximalNumber: number;

  private _buttonStateToCSSClassName = {
    active: 'chooseGridButton',
    disabled: 'chooseGridButtonBlocked',
  };

  private _helperTextStateToCSSClassName = {
    notTypedYet: 'notTypedYet',
    error: 'errorNotificationStyle',
  }




  constructor(
    private tournamentTunerService: TournamentTunerMethodsService
  ) { }

  ngOnInit(): void {
    this.tournamentTunerService.enableConventionalGridTypesList = this.gridTypesCanBeRequested();
  }

  ngOnDestroy(): void {
    this.tournamentTunerService.enableConventionalGridTypesList = false;
  }


  matchesPattern(pattern: RegExp, stringToCheck: string) {
    return Array.from(stringToCheck.matchAll(pattern)).length === stringToCheck.length;
  }

  gridRequiredClickHandler() {
    this.tournamentTunerService.tournamentGridRequired = !this.tournamentTunerService.tournamentGridRequired;
    this.tournamentTunerService.enableConventionalGridTypesList = this.tournamentTunerService.tournamentGridRequired && this.gridTypesCanBeRequested();
  }

  gridIsRequired(): boolean {
    return this.tournamentTunerService.tournamentGridRequired;
  }

  enableConventionalGridTypesList() {
    this.tournamentTunerService.enableConventionalGridTypesList = true;
  }

  disableConventionalGridTypesList() {
    this.tournamentTunerService.enableConventionalGridTypesList = false;
  }

  chooseGridButtonEnabled() {
    return this.tournamentTunerService.groupsAmount && this.tournamentTunerService.playersLeavingGroupNumber;
  }

  inputValueFilter($event) {
    const pattern: RegExp = /\d/g;
    const typedValue = $event.target.value;
    if(!(typedValue[0] > '0' && typedValue[0] <= '9')) {
      $event.target.value = '';
    } else {
      if (!this.matchesPattern(pattern, typedValue)) {
        $event.preventDefault();
        $event.target.value = typedValue.slice(0, -1);
      }
    }
  }

  getPlayersLeavingGroupsNumber(): number {
    return this.tournamentTunerService.playersLeavingGroupNumber;
  }

  setPlayersLeavingGroupsNumber(value: string) {
    const pattern: RegExp = /\d/g;
    if (this.matchesPattern(pattern, value) && value[0] > '0') {
      if (value) {
        this.tournamentTunerService.playersLeavingGroupNumber = parseInt(value);
      }
    }
    else {
      this.tournamentTunerService.playersLeavingGroupNumber = 0;
    }
  }

  getGroupsAmount() {
    return this.tournamentTunerService.groupsAmount;
  }

  setGroupsAmount(value: string) {
    const pattern: RegExp = /\d/g;
    if (this.matchesPattern(pattern, value) && value[0] > '0'){
      if (value) {
        this.tournamentTunerService.groupsAmount = parseInt(value);
      }
    } else {
      this.tournamentTunerService.groupsAmount = 0;
    }

  }

  permittedGroupsAmount(): boolean {
    if(this.tournamentTunerService.groupsAmount && this.tournamentTunerService.playersAmount) {
      this.groupsMaximalAmount = Math.trunc(this.tournamentTunerService.playersAmount / 2);

      return this.tournamentTunerService.groupsAmount <= this.groupsMaximalAmount;
    }
    return false;
  }

  permittedPlayersLeavingGroupNumber(): boolean {

    if (this.tournamentTunerService.groupsAmount && this.tournamentTunerService.playersAmount) {
      this.playersExitingGroupsMaximalNumber = Math.ceil(this.tournamentTunerService.playersAmount / this.tournamentTunerService.groupsAmount);

      return this.tournamentTunerService.playersLeavingGroupNumber <= this.playersExitingGroupsMaximalNumber
        && !!this.tournamentTunerService.playersLeavingGroupNumber;
    }

    return false
  }

  gridTypesCanBeRequested(): boolean {
    return this.permittedGroupsAmount() && this.permittedPlayersLeavingGroupNumber();
  }

  chooseGridTypeButtonStyle(): string {
    return this.gridTypesCanBeRequested()
      ? this._buttonStateToCSSClassName.active
      : this._buttonStateToCSSClassName.disabled;
  }

  messageToDisplay(exceeds: boolean, limitToDisplay: number, variableValue: any): string {
    const errorMessage = `Максимальное значение: ${limitToDisplay}`;
    const defaultMessage = 'Обязательно к заполнению';
    return !variableValue
      ? defaultMessage
      : exceeds
        ? errorMessage
        : '';
  }

  messageStyle(variable: any): string {
    return !variable
      ? this._helperTextStateToCSSClassName.notTypedYet
      : this._helperTextStateToCSSClassName.error;
  }

  handleChooseGridTypeButtonClick() {
    if (this.gridTypesCanBeRequested()) {
      this.tournamentTunerService.enableConventionalGridTypesList = true;
    }
  }

  handleGroupsOnlyClick() {
    this.tournamentTunerService.createGroupOnly(this.tournamentTunerService.tournamentId).subscribe(() => {
      window.location.href = window.location.href.replace('/players', '/groups');
    });
  }

  getThirdPlaceTournamentAvailable(): boolean {
    return this.tournamentTunerService.thirdPlaceTournamentAvailable;
  }

  setThirdPlaceTournamentAvailable() {
    this.tournamentTunerService.thirdPlaceTournamentAvailable
      = !this.tournamentTunerService.thirdPlaceTournamentAvailable;
  }

}
